const binding = { modules: {}, dataActions: {} };

    (binding.modules['list-of-links'] = {
        c: () => require('partner/modules/list-of-links/list-of-links.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'list-of-links',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/list-of-links'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };